 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"28155190fa60aef9e6cf82e06352be8535ce1c4b","1":"10ff32b4c9f3ffa04aa57aa7ea0e422fb5fafac7","2":"b4c22d6a7097ff8db6e951ee0d6d2493ac818fda","3":"cfdf7dc2ed5ac5c82bdea700bc32d25f853909e3","4":"a338a715e25d3671fbeb2d0b60dcec01cd85bb1c","5":"252f366e","6":"9bb998ff","7":"bd0395ec1df715690739642f1d72d7ad10f10d4e","8":"0629ae8e68dea316a27c981f265ff6b37f473016","9":"74b743768d7224142612e67f8be2d772e20516a1","10":"92ed08d946254adf765ba79c906ce985e8dadff9","11":"component---src-pages-services-tsx","13":"1b5eef04","15":"456ebb50","17":"632bb8f6","18":"959cbffc","21":"component---src-pages-404-tsx","22":"component---src-pages-company-tsx","23":"component---src-pages-contact-tsx","24":"component---src-pages-employees-tsx","25":"component---src-pages-english-services-tsx","26":"component---src-pages-family-clinic-tsx","27":"component---src-pages-guidance-tsx","28":"component---src-pages-jobs-tsx","29":"component---src-pages-kela-services-tsx","30":"component---src-pages-privacy-tsx","31":"component---src-pages-psychotherapies-tsx","32":"component---src-pages-qa-tsx","33":"component---src-pages-svenska-tjanster-tsx","34":"component---src-pages-swedish-services-tsx","35":"component---src-pages-trainings-tsx","36":"component---src-templates-blog-tsx","37":"component---src-templates-blogs-tsx","38":"component---src-templates-campaign-tsx","39":"component---src-templates-current-tsx","40":"component---src-templates-service-tsx","41":"e19d6005"}[chunkId]||chunkId) + "-" + {"0":"4039273f4e922747a999","1":"a02fa98fe73b7472aabd","2":"4778aea8883e5720f438","3":"5a0756953477207081b7","4":"8ac428b2ee09f1ecfc46","5":"7e92bdadc44ec51bd49f","6":"e45db04719359d621994","7":"ac5d8e7ba93687a33fcf","8":"0649400bb37611f138cd","9":"4d0c2d62b0833ca035f2","10":"2b7716117e94365ba9e7","11":"2526df9d184af853a02d","13":"0ea61cc9f5bf6a46209d","15":"2a5f7cc761374a20db42","17":"711c2482fe528fa086ea","18":"cd9ee8532f945e12cf01","21":"960183389a9c5efdbc43","22":"a039a2286bec353c37c9","23":"9ed419c330a783761f0e","24":"496f82b7721e9adffe2d","25":"e409db68531be3ff1091","26":"3c03d0236b6a0346ca18","27":"2f20550c1affbf8945c8","28":"6fd3bff0d163ae63cd8a","29":"4220237c412048c6d219","30":"95b90dd7d59bdf84da33","31":"d40188fc7eebcce06321","32":"6fde5a8b40baed978481","33":"b7339927af8f80abfde8","34":"921b9cb02d80f7a6833a","35":"0d884f0a764651db1137","36":"dc6387f628cd419327c0","37":"926c3d9e16b760a01265","38":"b1b46780bd8b34c7df8b","39":"a5b13b9906d905df2005","40":"315713618b79d7f7cf9c","41":"37cb083355af1781840b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
